/* Copy-to-clipboard for the promo bar discount code. */
(function () {
  function flash(btn) {
    var label = btn.querySelector('.aeloo-promo-bar__copied');
    if (label) label.textContent = btn.dataset.copiedLabel || 'Copied';
    btn.classList.add('is-copied');
    clearTimeout(btn._aelooTimer);
    btn._aelooTimer = setTimeout(function () {
      btn.classList.remove('is-copied');
    }, 1600);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (e) {
      /* nothing else we can do */
    }
    document.body.removeChild(ta);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.aeloo-promo-bar__copy');
    if (!btn) return;
    event.preventDefault();
    var code = btn.getAttribute('data-aeloo-copy') || '';
    if (!code) return;
    // navigator.clipboard needs a secure context; fall back where it is absent.
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () { flash(btn); },
        function () { fallbackCopy(code); flash(btn); }
      );
    } else {
      fallbackCopy(code);
      flash(btn);
    }
  });
})();

/* Play/pause for the "see it in action" clips. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.aeloo-clips__play');
    if (!btn) return;
    var item = btn.closest('.aeloo-clips__item');
    var video = item && item.querySelector('video');
    if (!video) return;
    event.preventDefault();
    // Pause any other clip so two never play over each other.
    document.querySelectorAll('.aeloo-clips__item.is-playing').forEach(function (other) {
      if (other === item) return;
      var v = other.querySelector('video');
      if (v) v.pause();
      other.classList.remove('is-playing');
    });
    video.muted = false;
    var played = video.play();
    if (played && played.catch) {
      played.catch(function () {
        // Autoplay policies can block unmuted playback; retry muted.
        video.muted = true;
        video.play();
      });
    }
    item.classList.add('is-playing');
    video.addEventListener('pause', function () {
      item.classList.remove('is-playing');
    });
  });
})();
